export default __webpack_public_path__ + "static/media/virtual-image.bd56e8e1.png";